function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
export var uniqueIdSet = new Set();
export function clearUniqueIds() {
  uniqueIdSet.clear();
}
export function registerUniqueId(identifier) {
  var num = 1;
  while (uniqueIdSet.has(identifier + num)) {
    num++;
  }
  uniqueIdSet.add(identifier + num);
  return identifier + num;
}
export function unregisterUniqueId(uniqueId) {
  if (uniqueIdSet.has(uniqueId)) {
    uniqueIdSet["delete"](uniqueId);
  }
}
var html4Id = /^[A-Za-z]+[\w\-:.]*$/;
export function withUniqueId(options) {
  var _ref = options || {},
    _ref$identifier = _ref.identifier,
    identifier = _ref$identifier === void 0 ? 'maria-uid' : _ref$identifier;
  if (identifier == null || !html4Id.test(identifier)) {
    throw new Error('[withUniqueId] identifier must be a HTML4 compatible id string starting with ASCII letter');
  }
  return function (Component) {
    var UniqueId = /*#__PURE__*/function (_React$PureComponent) {
      _inheritsLoose(UniqueId, _React$PureComponent);
      function UniqueId() {
        var _this;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
        _defineProperty(_assertThisInitialized(_this), "currentId", _this.props.id);
        _defineProperty(_assertThisInitialized(_this), "id", registerUniqueId(_this.props.id != null ? _this.props.id : identifier));
        _defineProperty(_assertThisInitialized(_this), "renderIds", {});
        _defineProperty(_assertThisInitialized(_this), "lastUid", function (id) {
          var key = typeof id === 'string' ? id : '';
          var array = _this.renderIds[key];
          return Array.isArray(array) && array[array.length - 1] || null;
        });
        _defineProperty(_assertThisInitialized(_this), "makeUids", function (ids) {
          if (Array.isArray(ids)) return ids.map(_this.nextUid);
          if (ids == null || typeof ids !== 'object') return null;
          return Object.keys(ids).reduce(function (output, key) {
            output[key] = _this.nextUid(ids[key]);
            return output;
          }, {});
        });
        _defineProperty(_assertThisInitialized(_this), "nextUid", function (id) {
          var key = typeof id === 'string' ? id : '';
          if (!Array.isArray(_this.renderIds[key])) _this.renderIds[key] = [];
          var uniqueId = registerUniqueId(_this.id + "." + key);
          _this.renderIds[key].push(uniqueId);
          return uniqueId;
        });
        _defineProperty(_assertThisInitialized(_this), "tools", [['last', _this.lastUid], ['make', _this.makeUids], ['next', _this.nextUid]].reduce(function (output, pair) {
          return Object.defineProperty(output, pair[0], {
            value: pair[1]
          });
        }, {}));
        _defineProperty(_assertThisInitialized(_this), "uniqueId", function () {
          _this.removeRenderGeneratedIds();
          return _this.tools;
        });
        _defineProperty(_assertThisInitialized(_this), "removeRenderGeneratedIds", function () {
          var keys = Object.keys(_this.renderIds);
          for (var j = 0; j < keys.length; j++) {
            var key = keys[j];

            // perf: only delete if not being used in two consecutive renders
            if (_this.renderIds[key].length === 0) {
              delete _this.renderIds[key];
            } else {
              while (_this.renderIds[key].length) {
                unregisterUniqueId(_this.renderIds[key].pop());
              }
            }
          }
        });
        return _this;
      } // storage for ids generated in components during render using next() or make()
      var _proto = UniqueId.prototype;
      _proto.componentWillUnmount = function componentWillUnmount() {
        this.removeRenderGeneratedIds();
        unregisterUniqueId(this.id);
      };
      _proto.render = function render() {
        var _this$props = this.props,
          forwardedRef = _this$props.forwardedRef,
          id = _this$props.id,
          props = _objectWithoutPropertiesLoose(_this$props, ["forwardedRef", "id"]);
        if (id !== this.currentId) {
          unregisterUniqueId(this.id);
          this.currentId = id;
          this.id = registerUniqueId(id != null ? id : identifier);
        }
        return React.createElement(Component, Object.assign({}, props, {
          ref: forwardedRef,
          id: this.id,
          uniqueId: this.uniqueId
        }));
      };
      return UniqueId;
    }(React.PureComponent); // eslint-disable-next-line react/display-name,react/no-multi-comp
    process.env.NODE_ENV !== "production" ? UniqueId.propTypes = {
      forwardedRef: PropTypes.any,
      id: PropTypes.string
    } : void 0;
    return React.forwardRef(function (props, ref) {
      return React.createElement(UniqueId, Object.assign({}, props, {
        forwardedRef: ref
      }));
    });
  };
}